import { render, staticRenderFns } from "./emailButtonElementViewer.vue?vue&type=template&id=04caf25a&scoped=true&"
import script from "./emailButtonElementViewer.vue?vue&type=script&lang=js&"
export * from "./emailButtonElementViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04caf25a",
  null
  
)

export default component.exports